module.exports = {"order":0,"item":"list","size":{"sm":12,"md":6,"lg":6,"xl":3},"data":{"name":"List","desc":"INFORMATION","list":{"data":[]}}}


//////////////////
// WEBPACK FOOTER
// ./src/views/site/Developer/DeveloperOverviewRender/Components/Data/List.json
// module id = 355
// module chunks = 0